import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css'
import fileSizeFilter from './filters/fileSizeFilter'
import dateFormat from './filters/dateFormat'
import { 
  Button,
  Card,
  Input,
  Icon,
  Menu,
  Table,
  Statistic,
  Upload,
  Avatar,
  Form,
  Radio,
  Tag,
  Popconfirm,
  Alert,
  Spin
} from 'ant-design-vue'
const comps = [
  Button,
  Card,
  Input,
  Icon,
  Menu,
  Menu.SubMenu,
  Menu.Item,
  Table,
  Statistic,
  Upload.Dragger,
  Avatar,
  Form,
  Form.Item,
  Radio.Group,
  Tag,
  Popconfirm,
  Alert,
  Spin
]
comps.forEach(comp => {
  Vue.component(comp.name, comp)
})
Vue.config.productionTip = false
// Vue.use(Antd)
Vue.filter('toFileSize', fileSizeFilter)
Vue.filter('dateFormat', dateFormat)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
